helpers = require('../../helpers.coffee')
module.exports = {
  methods:
    emitOpenCompose: ->
      if @task.isMeetingTask()
        EventsBus.$emit 'meeting-modal-show', { event, @task }
      else
        event.originalEventName = 'Compose::Open'
        EventsBus.$emit 'Compose::Open', { event, @task }

    toggleDone: ->
      if @showConfirmationModal
        EventsBus.$emit 'confirm-modal-show', { id: "confirm-task-done-#{@task.id}" }
      else if @showComposeMeeting
        EventsBus.$emit 'meeting-modal-show', { event, @task }
      else
        @doneTask()

    doneTask: ->
      @task.markAsDone()
      @tasks_resources.save @taskUpdated, @unknownError, @task.serialize(['id', 'done_at'])
      @trackIntercomDoneEvent()

    sendEmailDoneTask: ->
      @tasks_resources.get @loadTaskInfoSuccess, @unknownError, id: @task.id

    loadTaskInfoSuccess: (data) ->
      template = data.task.template

      if !template.body || !template.subject
        alertify.error('A tarefa não possui um template válido')
      else
        params = @buildParams(template)
        if @task?.isCreatedByUser()
          @tasks_resources.only_send_email @sendEmailSuccess, @unknownError, params
        else
          @tasks_resources.save_template_and_send_email @sendEmailSuccess, @unknownError, params

    buildParams: (template) ->
      shared_params = {
        subject: template.subject
        body: template.body
        kind: template.kind
        send_email: true
      }

      if @task?.isCreatedByUser()
        params = {
          task_id: @task.id
          template_id: template.id
        }
      else
        params = {
          id: @task.id
          signature: template.signature
        }

      Object.assign({}, params, shared_params)

    sendEmailSuccess: (data) ->
      alertify.success('E-mail disparado com sucesso')
      @task.markAsDone()
      EventsBus.$emit 'Task::Done', @task

    taskUpdated: (resources) ->
      alertify.success('Tarefa atualizada com sucesso')
      resources.task.assigned_to = @task.assigned_to
      @$emit 'task-updated', resources.task

    iconClass: (task) ->
      "#{task.slug}-icon"

    toggleTaskBar: (open_comment = false) ->
      event.originalEventName = 'toggle-task-bar'
      contact = @task.contact
      task = @task
      @$emit 'toggle-task-bar', { event, contact, task, open_comment }

    editTask: ->
      EventsBus.$emit 'TaskModalForm::Show', { task_id: @task.id, contact: null, id: 'manual-task-form-modal' }

    openDialer: (number, number_type, task, open_comment = false) ->
      event.originalEventName = 'open-dialer'
      data = { contact: task.contact, task: task, number: number, number_type: number_type, open_comment: open_comment }
      EventsBus.$emit 'open-dialer', data

    normalizePhone: (number) ->
      helpers.masks.maskPhone("+55" + number)

    trackIntercomDoneEvent: ->
      final_text = if @task.isDone() then 'realizada' else 'não realizada'
      IntercomCtrl.trackEvent("#{@origem} - tarefa marcada como #{final_text}",{
        'Identificador da tarefa': @task.id,
        'Identificador do contato': @task.contact.id
      })

    registerVoipCall: (task) ->
      if task.id == @task.id
        @task.voip_calls_count += 1
        @task.markAsDone()
        @$emit 'task-updated', task

    taskItemClass: ->
      item_class = "padding-#{@element_options.padding}"
      item_class += ' overdue-task-item' if @task.isOverdue() && !@task.isDueToday()
      item_class += ' future-task-item' if !@task.isOverdue() && !@task.isDueToday()
      item_class += ' scheduled' if @task.isScheduled()
      item_class += ' contact-show' if @element_options.description != "contact-info"
      item_class += ' ozzy-task' if @task.isOzzyTask()
      item_class

    mergeDefaultOptions: ->
      @element_options = Object.assign({}, @element_options, @options || {})

  computed:
    task_description: ->
      description = ''
      if @task.slug == 'phonecall-task' && (@task.contact.telephone || @task.contact.cellphone)
        if @task.voip_call_status
          description = @task.voip_call_status
        else
          description = 'Ligar para contato'
      else if @task.slug == 'email-task' && @task.contact.email
        description = "Enviar email"
      else if @task.slug == 'meeting-task' && @task.meeting_type
        description = @task.text + ' - ' + @task.meeting_type.title
      else description = @task.text
      description

    task_info: ->
      if @task.slug == 'phonecall-task' && (@task.contact.telephone || @task.contact.cellphone)
        @task.contact.telephone || @task.contact.cellphone
      else if @task.slug == 'email-task' && @task.contact.email
        @task.contact.email

    element_id: ->
      "task-#{@task.id}"

    show_call_button: ->
      @task.slug == "phonecall-task" && @task.assigned_to_id == @current_user.id && !@task.isDone()

    show_second_call_button: ->
      (!Session.current_user.plivo_endpoint || Session.current_company.isVoipExceeded() || !Session.current_company.isPlivo()) && @task.slug == "phonecall-task"

    disable_toggle_done: ->
      (!@task.canBeUndone() && @task.isDone()) || !@user_can_manage

    user_can_manage: ->
      return false if @current_user.isSeller() && @current_user.id != @task.assigned_to_id
      !@current_user.isMonitoringManager()

  beforeDestroy: ->
    EventsBus.$off 'voip-call-complete', @registerVoipCall
    @tooltip_content.$destroy() if @tooltip_content

}



// WEBPACK FOOTER //
// ./src/helpers/manual_tasks/list_item_wrapper.coffee